//用“导入”命令加载VUE构建版本
//(运行时单独或运行时)请在WebPACK.BASE.CONF中设置别名。
import Vue from 'vue'
import App from './App'
import router from './router'
import '../src/style/answer.css'
/*引入公共样式*/
import Request from '../src/js/request.js'
/*引入Ajax*/
import appFn from '../src/js/app.js' // 全局公共方法
import 'swiper/dist/css/swiper.min.css';
import '@/style/animate.css'//import '../src/style/animate.css'引入css动画样式  
// 网络请求对象
Vue.prototype.request = new Request();
// appfn
Vue.prototype.appfn = appFn;

Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js